import { useState } from 'react'

import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import DateHelper from 'common/helpers/date'
import Icons from 'common/components/icons'
import LimitedParagraph from 'common/components/limitedParagraph'
import { TransmissionInfo } from 'modules/transmission/types'

import './confirmLeadTitle.scss'

interface Props {
  transmission: TransmissionInfo,
  showConfirm: boolean
}

const ConfirmLeadTitle = ({ transmission, showConfirm }: Props) => {
  const { t } = useTranslation()

  const [isCollapsed, setIsCollapsed] = useState(true)

  const toggleIsCollapsed = () => setIsCollapsed(!isCollapsed)

  return (
    <div className={classnames('form-title', { 'is-confirmation': showConfirm })}>
      <h1>{transmission?.name}</h1>
      <div className="live-date-container">
        <div className="text">
          <span className="zone">{transmission?.zoneId}</span>
          {transmission
          && (
            <span className="time">{DateHelper.convertISODateToLocaleFormatted(
              transmission.liveStartAt,
              transmission.zoneId
            )}
            </span>
          )}
        </div>
        <div className="icon">
          <Icons prefix="far" iconName="calendar-alt" className="icon-calendar" />
        </div>
      </div>
      {
        transmission.description
      && (
        <LimitedParagraph
          collapse={isCollapsed}
          limit={120}
          className="description"
          onExpand={toggleIsCollapsed}
          readMoreButtonText={t('live-preview.read-more')}>
          {transmission && transmission.description}
        </LimitedParagraph>
      )
      }
      {
        !isCollapsed
      && (
        <button className="collapseDescription" onClick={toggleIsCollapsed}>
          <Icons prefix="far" iconName="times" />
        </button>
      )
      }
    </div>
  )
}

export default ConfirmLeadTitle
